'use strict';

/**
 * @ngdoc function
 * @name informaApp.directive:infAskAnalyst
 * @description
 * # infAskAnalyst
 * Directive of the informaApp
 */

angular.module('informaApp').directive('infAskAnalyst', ["AskAnalystSvc", "OmnitureSvc", "AuthenticationService", function (AskAnalystSvc, OmnitureSvc, AuthenticationService) {
    return {
        restrict: 'E',
        templateUrl: 'directives/inf-ask-analyst/template.ptl.html',

        scope: { },

        link: function(scope, element, attrs) {
            scope.showAskForm = false;
            scope.invalidFields = {};

            scope.openAskAnalystForm = function () {
                scope.showAskForm = !scope.showAskForm;

                if(scope.showAskForm) {
                    scope.questionToAnalyst = {};

                    scope.questionToAnalyst.email = AuthenticationService.getCurrentUser().email;
                }
            };

            scope.ask = function () {
                if(!scope.validate()) return;

                return AskAnalystSvc.sendQuestion(scope.questionToAnalyst)
                    .then(function(res) {
                        scope.showAskForm = !scope.showAskForm;
                        OmnitureSvc.trackAskTheAnalyst();
                    })
                    .catch(function(err) { console.log(err) });
            };

            scope.checkField = function (field) {
                scope.invalidFields[field] = !scope.questionToAnalyst[field];
            };

            scope.validate = function () {
                var fields = ['email', 'subject', 'message'],
                    valid = true;

                fields.forEach(function(field) {
                    scope.checkField(field);
                    if(valid) { valid = !scope.invalidFields[field] }
                });

                return valid;
            }
        }
    };
    }]);
//# sourceMappingURL=inf-ask-analyst.dir.js.map
